import React, { useState } from "react";
import { TextField, Button, Typography, Snackbar, Alert, Tooltip } from "@mui/material";
import getApiBase from "../components/getApiBase";

// TASK-816 I6: Invite still POSTs /api/invite; Owner lookup is Mechanic_Autoshops on the backend.

const InviteMechanic = ({ shopId, shopStatus }) => {
  const [email, setEmail] = useState("");
const [inviteLoading, setInviteLoading] = useState(false);

const [feedback, setFeedback] = useState({
  open: false,
  success: true,
  message: "",
});

  const handleInvite = async () => {
  if (inviteLoading) return;

  setInviteLoading(true);

  try {
    const response = await fetch(`${getApiBase()}/api/invite`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ email, shopId }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Error sending invite");
    }

    setFeedback({
      open: true,
      success: true,
      message: data.message || "Invite sent successfully",
    });

    setEmail("");
  } catch (err) {
    console.error("❌ Invite Error:", err);

    setFeedback({
      open: true,
      success: false,
      message: err.message || "Server error sending invite",
    });
  } finally {
    setInviteLoading(false);
  }
};

  const isShopActive = shopStatus === 'Active';

  return (
    <div style={{ maxWidth: 500, margin: "auto", padding: 20 }}>
      <Typography variant="h5">Invite Mechanic</Typography>
      <TextField
        fullWidth
        label="Mechanic's Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        margin="normal"
        disabled={!isShopActive}
      />
      <Tooltip
        title={
          !isShopActive
            ? `Your shop must be Active to invite mechanics (currently ${shopStatus || 'Unknown'})`
            : ""
        }
        arrow
      >
        <span>
          <Button
  variant="contained"
  onClick={handleInvite}
  disabled={!isShopActive || !email || inviteLoading}
>
  {inviteLoading ? "Sending Invite..." : "Send Invite"}
</Button>
        </span>
      </Tooltip>
      {!isShopActive && (
        <Typography 
          variant="body2" 
          color="error" 
          sx={{ mt: 2 }}
        >
          ⚠️ Your shop must be Active to invite mechanics. Current status: {shopStatus || 'Unknown'}
        </Typography>
      )}
      <Snackbar
        open={feedback.open}
        autoHideDuration={6000}
        onClose={() => setFeedback({ ...feedback, open: false })}
      >
        <Alert severity={feedback.success ? "success" : "error"}>
          {feedback.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default InviteMechanic;
